// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"ImageHeader-module--header-wrapper--2n0dP","title":"ImageHeader-module--title--2ZuDp"};